module.exports = __webpack_public_path__ + "img/newN.18ec22d6.svg";